<div class="load-container">
  <div class="container">
    @if (authStatus.icon === 'app-loading') {
      <i [ngClass]="'app-loading'"></i>
    } @else {
      <mat-icon [fontIcon]="authStatus.icon"></mat-icon>
    }
    <div>{{ authStatus.text }}</div>
  </div>
</div>
